import React from 'react';
import { Link } from 'react-router-dom';

const COPY = {
  en: {
    eyebrow: 'CONTACT',
    heading: 'Send a note.',
    lede: "For questions, partnerships, media, and other inquiries. If you're already sure you want a systems review, request an audit instead.",
    audit_link: 'Request an audit',
  },
  es: {
    eyebrow: 'CONTACTO',
    heading: 'Envíanos un mensaje.',
    lede: 'Para preguntas, alianzas, medios y otras consultas. Si ya tienes claridad de que quieres una revisión de sistemas, mejor solicita una auditoría.',
    audit_link: 'Solicitar una auditoría',
  },
};

const ContactHeroV2 = ({ lang = 'en' }) => {
  const t = COPY[lang] || COPY.en;
  return (
    <section className="iv2-contact-hero" data-testid="iv2-contact-hero">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{t.eyebrow}</p>
        <h1 className="iv2-contact-hero-title" data-testid="iv2-contact-heading">
          {t.heading}
        </h1>
        <p className="iv2-contact-hero-lede">
          {t.lede}{' '}
          <Link to={`/v2/audit?lang=${lang}`} className="iv2-contact-hero-alt" data-testid="iv2-contact-hero-audit-link">
            {t.audit_link} →
          </Link>
        </p>
      </div>
    </section>
  );
};

export default ContactHeroV2;
